<template>
  <div class="content">
      <div class="block block-rounded block-fx-shadow mb-3">
        <div class="block-header">
          <h3 class="block-title">{{ $t('contragents.index') }}</h3>
          <div class="block-options">
              <b-btn v-b-modal.addContragent size="sm" variant="primary" class="float-right">{{ $t('contragents.add') }}</b-btn>
          </div>
      </div>
        <table class="table table-hover table-bordered bg-white table-striped">
          <thead>
            <th>#</th>
            <th>{{ $t('app.id') }}</th>
            <th width="20 px">{{ $t('app.action') }}</th>
            <th>{{ $t('contragents.name') }}</th>
            <th>{{ $t('contragents.bin') }}</th>
            <th>{{ $t('contragents.debts_count_short') }}</th>
            <th>{{ $t('contragents.debts_total_amount') }}</th>
            <th>{{ $t('contragents.description') }}</th>
          </thead>
          <tbody>
            <template v-if="!loadContragents">
              <tr v-for="(contragent, index) in contragents" :key="contragent.id">
                <td >{{index+1}}</td>
                <td >{{contragent.id}}</td>
                <td>
                  <div class="btn-group" role="group" aria-label="btnGroup1">
                    <button @click.prevent="initUpdate(index)" class="btn btn-primary btn-sm">
                      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </button>
                    <button @click.prevent="handleDelete(contragent.id)" class="btn btn-danger btn-sm " :disabled="isProcessing" >
                      <i class="fa fa-times-circle"></i>
                    </button>
                  </div>
                </td>
                <td >{{contragent.name}}</td>
                <td >{{contragent.bin}}</td>
                <td >{{contragent.debts_count}}</td>
                <td >{{contragent.current_arrears | formatNumber}} {{ $t('app.kzt') }}</td>
                <td >{{contragent.description}}</td>
              </tr>
            </template>
            <tr v-if="loadContragents">
              <td colspan="8" class="text-center">
                <loader-wave />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-modal
        id="addContragent"
        size="lg"
        :title="$t('contragents.add_title')"
        ref="modalAddContragent"
        @ok="handleStore"
        :ok-title="$t('buttons.ok')"
        :cancel-title="$t('buttons.cancel')"
        @ok-disabled="isProcessing"
      >
        <div class="form-group">
          <label for="storename" class="col-form-label">{{ $t('contragents.name') }}</label>
          <input type="text" class="form-control" v-model="contragent.name" id="storename" :class="{'is-invalid': errors.name }">
          <span v-if="errors.name" class="invalid-feedback">
              <strong>{{ errors.name ? errors.name[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="storebin" class="col-form-label">{{ $t('contragents.bin') }}</label>
          <input type="text" class="form-control" v-model="contragent.bin" id="storebin" maxlength="12" :class="{'is-invalid': errors.bin }">
          <span v-if="errors.bin" class="invalid-feedback">
              <strong>{{ errors.bin ? errors.bin[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="storedeck" class="col-form-label">{{ $t('contragents.description') }}</label>
          <textarea class="form-control" v-model="contragent.description" id="storedeck" rows="3"></textarea>
        </div>
      </b-modal>

      <b-modal
        size="lg"
        :title="$t('contragents.edit_title')"
        ref="modalUpdateContragent"
        @ok="handleUpdate"
        :ok-title="$t('buttons.ok')"
        :cancel-title="$t('buttons.cancel')"
        @ok-disabled="isProcessing"
      >
        <div class="form-group">
          <label for="storename" class="col-form-label">{{ $t('contragents.name') }}</label>
          <input type="text" class="form-control" v-model="update_contragent.name" id="storename" :class="{'is-invalid': update_errors.name }">
          <span v-if="update_errors.name" class="invalid-feedback">
              <strong>{{ update_errors.name ? update_errors.name[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="updatebin" class="col-form-label">{{ $t('contragents.bin') }}</label>
          <input type="text" class="form-control" v-model="update_contragent.bin" id="updatebin" maxlength="12" :class="{'is-invalid': update_errors.bin }">
          <span v-if="update_errors.bin" class="invalid-feedback">
              <strong>{{ update_errors.bin ? update_errors.bin[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="storedeck" class="col-form-label">{{ $t('contragents.description') }}</label>
          <textarea class="form-control" v-model="update_contragent.description" id="storedeck" rows="3"></textarea>
        </div>
      </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contragents: [],
      contragent: {
        name: '',
        bin: '',
        description: '',
      },
      update_contragent: {
        name: '',
        bin: '',
        description: '',
      },
      pagination: {
        current_page: 1,
      },
      errors: {},
      update_errors: {},
      loadContragents: false,
      isProcessing: false,
    };
  },
  mounted() {
    this.fetchContragents();
  },
  methods: {
    fetchContragents() {
      this.loadContragents = true;
      window.axios.get('/admin/contragents')
        .then((res) => {
          this.contragents = res.data.contragents;
        })
        .finally(() => {
          this.loadContragents = false;
        });
    },

    clearModal() {
      this.contragent.name = '';
      this.contragent.bin = '';
      this.contragent.description = '';
      this.errors = {};
    },

    clearUpdateModal() {
      this.update_contragent.name = '';
      this.update_contragent.bin = '';
      this.update_contragent.description = '';
      this.update_errors = {};
    },

    initUpdate(index) {
      this.update_errors = {};
      this.$refs.modalUpdateContragent.show();
      this.update_contragent = this.contragents[index];
    },

    handleStore(evt) {
      evt.preventDefault();
      this.isProcessing = true;
      this.storeContragent();
    },

    handleUpdate(evt) {
      evt.preventDefault();
      this.isProcessing = true;
      this.updateContragent();
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deleteContragent(id);
        }
      });
    },

    storeContragent() {
      window.axios.post('/admin/contragents', this.contragent)
        .then((res) => {
          if (res.status === 201) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.$refs.modalAddContragent.hide();
            this.clearModal();
            this.fetchContragents();
          }
        })
        .catch((err) => {
          this.errors = {};
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    updateContragent() {
      window.axios.put(`/admin/contragents/${this.update_contragent.id}`, this.update_contragent)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.modalUpdateContragent.hide();
            this.clearUpdateModal();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchContragents();
          }
        })
        .catch((err) => {
          this.update_errors = {};
          this.update_errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    deleteContragent(id) {
      this.isProcessing = true;
      window.axios.delete(`/admin/contragents/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchContragents();
          }
          this.isProcessing = false;
        });
    },

  },
};
</script>
